// Platform to badge variant mapping
const PLATFORM_VARIANT_MAP = {
  apex: "primary",
  axon: "primary",
  flock: "positive"
};

/**
 * Maps a platform value to a badge variant
 * @param {string|null|undefined} value - The platform value to map
 * @returns {"positive"|"primary"|"secondary"|"neutral"} The badge variant
 */
export const getBadgeVariant = value => {
  if (!value?.trim()) return "neutral";

  const normalizedValue = value.toLowerCase().trim();
  return PLATFORM_VARIANT_MAP[normalizedValue] || "neutral";
};
